import { render, staticRenderFns } from "./ContentProviederEduSell.vue?vue&type=template&id=61b73385&scoped=true&"
import script from "./ContentProviederEduSell.vue?vue&type=script&lang=js&"
export * from "./ContentProviederEduSell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b73385",
  null
  
)

export default component.exports